import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  option: {
    display: 'block',
    position: 'relative',
    marginBottom: 10,
    padding: ({ small }) => (small ? '11px 14px 11px 14px' : '11px 20px'),
    width: '100%',
    borderRadius: 20,
    fontSize: ({ small }) => (small ? 14 : 16),
    fontWeight: 400,
    wordBreak: 'break-word',
    color: '#000',
    border: '1px solid #FF8C69',
    textAlign: 'unset',
    textTransform: 'initial',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      padding: '11px 14px 11px 14px',
      fontSize: 14,
    },
    '&:hover': {
      backgroundColor: '#fff4f1',
      color: '#FF8C69',
    },
    '@media(hover: none)': {
      backgroundColor: '#fff !important',
      color: '#000 !important',
    },
    '& .MuiButton-label': {
      pointerEvents: 'none',
    },

    [theme.breakpoints.down('sm')]: {
      padding: '11px 14px 11px 14px',
      fontSize: 14,
    },

  },
  checkedOption: {
    color: '#ffffff',
    fontWeight: 500,
    backgroundColor: '#FF8C69 !important',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: '#FF8C69 !important',
    },
  },
  optionIcon: {
    display: 'none',
    position: 'absolute',
    width: 42,
    height: 28,
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    [theme.breakpoints.down('sm')]: {
      right: 8,
    },
  },
  optionCheckBoxIcon: {
    marginRight: 12,
    color: '#FF8C69',
  },
  optionCheckBoxOutline: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #000000',
    borderRadius: '3px',
    height: 16,
    width: 16,
    marginRight: 12,
    marginLeft: 4,
    '& svg': {
      color: '#ffffff',
      width: 16,
      [theme.breakpoints.down('sm')]: {
        visibility: 'hidden',
      },
    },
  },
  fixedOptionCheckBoxChecked: {
    '& svg': {
      color: '#FF8C69',
      [theme.breakpoints.down('sm')]: {
        visibility: 'visible',
      },
    },
  },
  fixedCheckedOptionsClass: {
    display: 'flex',
    justifyContent: 'flex-start',
    color: '#ffffff',
    border: '1px solid #FF8C69 !important',
    backgroundColor: '#FF8C69 !important',
    '&:hover': {
      color: '#ffffff !important',
      borderColor: '#FF8C69',
      backgroundColor: '##FF8C69 !important',
    },
  },
}));
